import { render } from "./ProjectsDetailView.vue?vue&type=template&id=44b8f927"
import script from "./ProjectsDetailView.vue?vue&type=script&lang=js"
export * from "./ProjectsDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__